import React from 'react';

import { Box, Button, Paper, Typography } from '@material-ui/core';
import { Link } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    padding: theme.spacing(2)
  },
  banner: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-around',
    alignItems: 'center',
    maxWidth: 900,
    padding: theme.spacing(1),
    backgroundColor: '#ffe4e9',
    color: '#a7002d',
    textAlign: 'center',
    borderRadius: theme.shape.borderRadius,
    boxShadow: theme.shadows[2],
    border: '1px solid #f8b7c3'
  },
  icon: {
    fontSize: 40,
    color: '#d81b60',
    marginBottom: theme.spacing(1),
    marginRight: theme.spacing(1)
  },
  button: {
    marginBottom: theme.spacing(1),
    marginLeft: theme.spacing(1),
    backgroundColor: '#d81b60',
    color: '#fff',
    '&:hover': {
      backgroundColor: '#ad1457'
    }
  }
}));

const AnnotationsManualRetryBox = ({ onRetry }) => {
  const classes = useStyles();

  return (
    <Box className={classes.root}>
      <Paper className={classes.banner} elevation={3}>
        <ErrorOutlineIcon className={classes.icon} />
        <Typography variant="h6" gutterBottom>
          Something went wrong while extracting some of the insights. If this
          issue persists please contact us through{' '}
          <Link href="mailto:support@edlight.com">support@edlight.com</Link>.
        </Typography>
        <Button
          variant="contained"
          onClick={onRetry}
          className={classes.button}
        >
          Retry
        </Button>
      </Paper>
    </Box>
  );
};

export default AnnotationsManualRetryBox;
